
export default {
	props: {
		alt: {
			required: false,
			type: Boolean,
			default: () => false,
		},
	},
};
